var Mn = require('backbone.marionette'),
    helper = require('../libs/helpers');
module.exports = Mn.Behavior.extend({
    onAttach: function (view) {
        this.build(view.$el);
    },
    onChildviewAttach: function (view) {
        var content = view.$el;

        if (content.find('[data-collapse]').length) {
            this.build(content);
        }
    },
    build: function (content) {
        $('[data-collapse]', content).each(function() {
            var $article = $(this);
            var $body = $article.find('[data-collapse-body]');

            var $open = $article.find('[data-open]');
            
            $body.slideUp(300, function() {
                $article.removeClass('open');
            });
            
            if ($open.length > 0) {
                $body.slideUp(300, function() {
                    $(this).show();
                    $article.addClass('open');
                });
            }
        });

        $('[data-collapse] header', content).click(function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            var $article = $(this).parents('[data-collapse]');
            var $body = $article.find('[data-collapse-body]');

            if ($article.hasClass('open')) {
                $body.slideUp(300, function() {
                    $article.removeClass('open');
                });
            } else {
                $('[data-collapse]').find('[data-collapse-body]').slideUp(300, function() {
                    $(this).parents('[data-collapse]').removeClass('open');
                });

                $body.slideDown(300, function() {
                    $article.addClass('open');
                    helper.anchor($article);
                });
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/behaviors/Collapse.js
// module id = 225
// module chunks = 3